:host {
  --label-color: var(--stzh-radio-label-color, #{$baseColor});
  --label-hover-color: var(--stzh-radio-label-hover-color, #{$colorPrimary70});
  --label-hover-checked-color: var(
    --stzh-radio-label-hover-checked-color,
    #{$colorPrimary90}
  );

  display: inline-block;

  &[disabled]:not([disabled="false"]) {
    --description-color: #{$formDisabledColor};
  }
}

.stzh-radio {
  @include input-description;
  display: grid;

  &__field-wrapper {
    @include fontSize("milli");
    position: relative;
    display: flex;
    user-select: none;
    cursor: pointer;
  }

  &__input {
    @include visuallyhiddenInput;
    border-radius: $formInputBorderRadius;
  }

  &__mark {
    @include radio__mark();
  }

  &__check {
    @include radio__check();
  }

  &__label {
    --stzh-base-color: initial;

    display: inline-block;
    color: var(--label-color);
    transition: color $baseTransitionAnimationSpeed;
    margin-left: space("small");
    line-height: 24px;

    &:empty {
      display: none;
    }
  }

  &__marker {
    @include fontSize("micro");
    margin-left: calc(-0.25em + #{space("xsmall")});
  }

  /* Hover / Focus / Checked */

  &:hover &__label,
  &__input:checked ~ &__label {
    color: var(--label-hover-color);
  }

  &__input:checked:hover ~ &__label,
  &__input:checked:hover ~ &__mark &__check {
    color: var(--label-hover-checked-color);
  }

  &:hover &__mark,
  &__input:checked ~ &__mark {
    border-color: var(--label-hover-color);
  }

  &__input:checked:hover ~ &__mark {
    border-color: var(--label-hover-checked-color);
  }

  &__input:checked ~ &__mark &__check {
    opacity: 1;
  }

  /* Invalid */

  &--is-invalid &__input ~ &__label,
  &--is-invalid &__input ~ &__mark &__check {
    color: $colorError60;
  }

  &--is-invalid &__input ~ &__mark {
    border-color: $colorError60;
  }

  /* Disabled */

  &--is-disabled &__field-wrapper {
    cursor: not-allowed;
  }

  &--is-disabled &__input ~ &__label {
    color: $colorGrey60;
  }

  &--is-disabled &__input ~ &__mark &__check {
    color: $colorGrey50;
  }

  &--is-disabled &__input ~ &__mark {
    border-color: $colorGrey50;
  }

  &--is-disabled &__mark {
    background-color: $colorGrey20;
  }
}
